import React from "react";

export default function AdsListing({
  image,
  title,
  distance,
  city,
  description,
}) {
  return (
    <section className='d-flex ads-section'>
      <figure>
        <img src={image && image} alt='ad-one'/>
      </figure>
      
      <article>
        <span>{title ?? "-"}</span>
        <span>{distance ?? "-"}</span>
        <span>{city ?? "-"}</span>
        <span>{description ?? "-"}</span>
      </article>
    </section>
  );
}
